import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { EntityReferenceBasic, TagLabel } from '@/shared/types';

import type { DomainItem } from '@/entities/domain';

type DomainType = 'Source-aligned' | 'Consumer-aligned' | 'Aggregate';

type CreateDomainRequest = {
  domainType: DomainType;
  name: string;
  displayName?: string;
  description?: string;
  parent?: string;
  owners?: EntityReferenceBasic[];
  experts?: string[];
  tags?: TagLabel[];
};

export const createDomainApi = async (request: CreateDomainRequest): Promise<DomainItem> => {
  const { data } = await openMetadataApiClient.put<DomainItem>('/domains', request);
  return data;
};

export type { CreateDomainRequest, DomainType };
